import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { AuthStore } from './auth.store';

/**
 * Phase 18 v1.4 — KYC-02 admin guard.
 *
 * Gates `/admin/**` routes. Reads `MeResponse.isAdmin` directly from
 * AuthStore (kept in lockstep with `AuthService.isAdmin()` signal).
 *
 * UX hint only — the server-side AdminGuard (DB-backed `User.isAdmin`
 * lookup per request) is the authoritative check. We hide the routes
 * client-side to avoid showing 403 dead-ends on the founder-only screens.
 *
 * Non-admin users are bounced to `/` which the bootstrap+authGuard chain
 * will then redirect into their shell (empresa or profissional) without
 * exposing the admin route's existence.
 */
export const adminGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);
  if (authStore.user()?.isAdmin === true) return true;
  return router.parseUrl('/');
};
